export default "__VITE_ASSET__2fd508fa__"